import { Injectable } from '@angular/core';
import { BaseApiService } from '@ep/shared';
import { catchError, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VerticalService extends BaseApiService {
  private readonly verticalEndpoint = `/v2/Verticals`;

  findAll() {
    return this.get(`${this.verticalEndpoint}`).pipe(
      catchError((err) => {
        console.error(err);
        return of(null);
      })
    );
  }
}
